import React, { useState, useEffect } from 'react';
import FlapDigit from './FlapDigit';

const FlapStack = ({ targetChar, timing, onTargetReached, index }) => {
    const alphabet = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const [currentChar, setCurrentChar] = useState('A');
  
    useEffect(() => {
      const targetIndex = alphabet.indexOf(targetChar.toUpperCase());
  
      const timer = setInterval(() => {
        setCurrentChar(prevChar => {
          const currentIndex = alphabet.indexOf(prevChar);
          const nextIndex = (currentIndex + 1) % alphabet.length;
  
          if (nextIndex === targetIndex) {
            clearInterval(timer);
            onTargetReached(index, true); // Notify when target is reached
          }
  
          return currentIndex === targetIndex ? prevChar : alphabet[nextIndex];
        });
      }, timing);
  
      return () => clearInterval(timer);
    }, [targetChar, timing, onTargetReached, index]);
  
    return <FlapDigit value={currentChar} />;
  };
  
  export default FlapStack;
  
  
